import { render, staticRenderFns } from "./VisaNoEdit.vue?vue&type=template&id=6660c7ce&"
import script from "./VisaNoEdit.vue?vue&type=script&lang=js&"
export * from "./VisaNoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports